export const googleKey = "AIzaSyAQQuGSFwzVG6c8BObzq1Rxcd1dcKwRD8I";
